import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ROUTES } from "components/Common/Constants";

export const useDocumentTitle = () => {
  const location = useLocation();;
  const [title, setTitle] = useState("");  
  
  useEffect(() => {
      const { pathname } = location;
      const org = window.location.hostname.split('.')[0].toUpperCase();;
      const routeKeys = Object.keys(ROUTES);
      let route;
      if (pathname === '/') {
        route = routeKeys.filter(route => route === 'DEFAULT')
      } else {
        route = routeKeys.filter(route => ROUTES[route].link === pathname); 
      }
      setTitle(org + ' ' + (route.length ? ROUTES[route].title : ''));
  }, [location]);

  return title;
};
